import { Select } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import WrongZoneConfirmationModal from 'components/OpsControl/WrongZone/components/WrongZoneConfirmationModal/WrongZoneConfirmationModal';

import { ReactComponent as Hubs } from 'assets/bosta-icons/hubs.svg';
import { ReactComponent as ChevronDownIcon } from 'assets/bosta-icons/Chevron-down.svg';

const FlagToHubModal = ({
  allHubs,
  loading,
  flagDeliveriesToHub,
  deliveryIds,
  ...props
}) => {
  const [newHub, setNewHub] = useState();

  const intl = useIntl();

  const handleChangeNewHub = (selectedHub) => {
    setNewHub(selectedHub);
  };

  const onSuccess = () => {
    flagDeliveriesToHub(deliveryIds, newHub);
  };
  return (
    <WrongZoneConfirmationModal
      icon={<Hubs />}
      onSuccess={onSuccess}
      {...props}
      disableConfirmButton={!newHub}
      title={intl.formatMessage({
        id: 'ops_control.hub_deliveries.deliveries_table.flag_to_hub'
      })}
    >
      <div className="br-ops-control-wrong-zone__destination-hub-select">
        <Select
          showSearch
          key={newHub}
          loading={loading}
          disabled={loading || !allHubs?.length}
          options={allHubs}
          value={newHub}
          onChange={handleChangeNewHub}
          optionFilterProp="name"
          suffixIcon={<ChevronDownIcon />}
          fieldNames={{ label: 'name', value: '_id' }}
          dropdownMatchSelectWidth
          placeholder={intl.formatMessage({ id: 'zoning.hub_placeholder' })}
        />
      </div>
    </WrongZoneConfirmationModal>
  );
};

export default FlagToHubModal;
